import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "@store";

interface State {
  data: any;
  error: any;
  loading: any;
}
const initialState: State = {
  data: {},
  error: {},
  loading: false,
};
export const getAdminProfile = createSlice({
  name: "getAdminProfile",
  initialState,
  reducers: {
    setGetAdminProfileSuccess: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.loading = false;
    },
    setGetAdminProfileFailure: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    setAdminProfileOngoing: (state) => {
      state.data = {};
      state.loading = true;
      state.error = {};
    },
  },
});
export const { setGetAdminProfileSuccess, setGetAdminProfileFailure, setAdminProfileOngoing } =
  getAdminProfile.actions;
export const getAdminProfileStatus = (state: RootState) => state.getAdminProfile;
export const adminProfileReducer = getAdminProfile.reducer;
